import {
    CREATE_GENERAL_INWARD_DETAILS_FAILURE_DK,
    CREATE_GENERAL_INWARD_DETAILS_REQUEST_DK,
    CREATE_GENERAL_INWARD_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_GENERAL_INWARD_DETAILS_DK,
    DELETE_GENERAL_INWARD_DETAILS_FAILURE_DK,
    DELETE_GENERAL_INWARD_DETAILS_REQUEST_DK,
    DELETE_GENERAL_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_GENERAL_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_GENERAL_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_GENERAL_INWARD_DETAILS_SUCCESS_DK,
    FETCH_GENERAL_INWARD_DETAILS_FAILURE_DK,
    FETCH_GENERAL_INWARD_DETAILS_REQUEST_DK,
    FETCH_GENERAL_INWARD_DETAILS_SUCCESS_DK,
    GENERAL_INWARD_DETAILS_USERFORM_RESET_DK,
    UPDATE_GENERAL_INWARD_DETAILS_FAILURE_DK,
    UPDATE_GENERAL_INWARD_DETAILS_REQUEST_DK,
    UPDATE_GENERAL_INWARD_DETAILS_SUCCESS_DK,
    FETCH_GENERAL_INWARD_DETAILS_BY_ID_REQUEST_DK,
    FETCH_GENERAL_INWARD_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_GENERAL_INWARD_DETAILS_BY_ID_FAILURE_DK,
    FETCH_PREVIOUS_GENERAL_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_GENERAL_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_GENERAL_INWARD_DETAILS_FAILURE_DK,
    GENERAL_INWARD_DETAILS_PO_DETAILS_DISABLED_DK
} from './generalInwardDetails.actionsType';

export const GENERAL_INWARD_DETAILS_DK = 'generalInwardDKDetails';

let initialState = {
    loading: false,
    generalInwardDetailsById: [],
    generalInwardDetails: [],
    previousGetList: [],
    isPoDetailsDisabled:[],
    generalInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0
    },
    selectedFabricDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let generalInwardDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_GENERAL_INWARD_DETAILS_REQUEST_DK:
        case FETCH_GENERAL_INWARD_DETAILS_BY_ID_REQUEST_DK:
        case FETCH_PREVIOUS_GENERAL_INWARD_DETAILS_REQUEST_DK:
        case CREATE_GENERAL_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_GENERAL_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_GENERAL_INWARD_DETAILS_REQUEST_DK:
        case DELETE_GENERAL_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalInwardDetails: updatePayload
            };
        case FETCH_GENERAL_INWARD_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalInwardDetailsById: updatePayload
            };
            case FETCH_PREVIOUS_GENERAL_INWARD_DETAILS_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    previousGetList: updatePayload?.GPB
                };
        case CREATE_GENERAL_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled:false,
            };
        case FETCH_SINGLE_GENERAL_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedFabricDetails: updatePayload,
                generalInwardDetailsForm: {
                    ...updatePayload
                }
            };
        case UPDATE_GENERAL_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedFabricDetails: {},
                generalInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled:false,
            };
        case DELETE_GENERAL_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled:false,
                selectedFabricDetails: {}
            };

        case FETCH_GENERAL_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_GENERAL_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_GENERAL_INWARD_DETAILS_FAILURE_DK:
        case CREATE_GENERAL_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_GENERAL_INWARD_DETAILS_FAILURE_DK:
        case DELETE_GENERAL_INWARD_DETAILS_FAILURE_DK:
        case FETCH_GENERAL_INWARD_DETAILS_BY_ID_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_GENERAL_INWARD_DETAILS_DK:
            return {
                ...state,
                loading: false,
                generalInwardDetailsForm: {
                    ...state.generalInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
            case GENERAL_INWARD_DETAILS_PO_DETAILS_DISABLED_DK:
                return {
                    ...state,
                    isPoDetailsDisabled: payload
                };
        case GENERAL_INWARD_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                generalInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled:false,
                selectedFabricDetails: {}
            };
        default:
            return state;
    }
};
